import { Component, Inject, OnInit } from '@angular/core';
import { IotaModalOptions, IotaModalSize, MAT_DIALOG_DATA, MatDialogRef } from '@iota/iota-ui-components';
import { ButtonStyle } from '../../constants-and-enums/button-style';

export interface ConfirmationDialogData {
    title: string;
    text: string;
    cancelButtonStyle?: ButtonStyle;
    cancelButtonClass?: string;
    confirmButtonStyle?: ButtonStyle;
}

@Component({
    standalone: false,
    selector: 'app-dialog-confirmation',
    templateUrl: './dialog-confirmation.component.html',
    styleUrls: ['./dialog-confirmation.component.scss']
})
export class DialogConfirmationComponent implements OnInit {
    public modalOptions: Partial<IotaModalOptions> = {
        size: IotaModalSize.SMALL,
        showToggleFullScreenButton: false
    };

    constructor(
        public dialogRef: MatDialogRef<DialogConfirmationComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData
    ) {}

    cancelButtonStyle = 'btn-ghost';
    confirmButtonStyle = 'btn-primary';

    ngOnInit(): void {
        if (this.data.cancelButtonStyle) {
            this.cancelButtonStyle = 'btn-' + this.data.cancelButtonStyle;
        }
        if (this.data.cancelButtonClass) {
            this.cancelButtonStyle = this.data.cancelButtonClass;
        }

        if (this.data.confirmButtonStyle) {
            this.confirmButtonStyle = 'btn-' + this.data.confirmButtonStyle;
        }
    }

    onNoClick() {
        this.dialogRef.close();
    }

    onYesClick() {
        this.dialogRef.close(true);
    }

    closeModal() {
        this.dialogRef.close();
    }
}
